module.exports = __webpack_public_path__ + "static/media/wifi.909f9a88.svg";